module.exports = __webpack_public_path__ + "img/Polygon-2.e333d762.svg";